<template>
    <div v-loading="dataLoading">
        <template v-if="data">
            <div class="group">
                <div class="page-group-title"><span>用户信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col><span class="color-info">用户身份: </span>{{$userType.get(data.userType)}}</el-col>
                        <el-col><span class="color-info">用户ID: </span>{{data.id}}</el-col>
                        <el-col><span class="color-info">用户名称: </span>{{data.name}}</el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col>
                            <span class="color-info">收款联系人姓名: </span>{{data.userName}} 
                            <span v-if="data.beforeUserName" class="color-danger">(之前的内容: {{data.beforeUserName}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">收款联系人手机: </span>{{data.userTelephone}} 
                            <span v-if="data.beforeUserTelephone" class="color-danger">(之前的内容: {{data.beforeUserTelephone}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">收款联系人邮箱: </span>{{data.userEmail}} 
                            <span v-if="data.beforeUserEmail" class="color-danger">(之前的内容: {{data.beforeUserEmail}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">通讯地址: </span>{{data.address}} 
                            <span v-if="data.beforeAddress" class="color-danger">(之前的内容: {{data.beforeAddress}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">银行: </span>{{data.bank}} 
                            <span v-if="data.beforeBank" class="color-danger">(之前的内容: {{data.beforeBank}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">开户网点: </span>{{data.bankAddress}} 
                            <span v-if="data.beforeBankAddress" class="color-danger">(之前的内容: {{data.beforeBankAddress}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">卡号: </span>{{data.bankCardId}} 
                            <span v-if="data.beforeBankCardId" class="color-danger">(之前的内容: {{data.beforeBankCardId}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">账户名: </span>{{data.bankAccount}} 
                            <span v-if="data.beforeBankAccount" class="color-danger">(之前的内容: {{data.beforeBankAccount}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">账户性质: </span>{{accountType.get(data.accountType)}} 
                            <span v-if="data.beforeAccountType" class="color-danger">(之前的内容: {{accountType.get(data.beforeBankAccount)}})</span>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col v-if="data.accountType == 2">
                            <span class="color-info">证件类型: </span>{{data.accountIdName}} 
                            <span v-if="data.beforeAccountIdName" class="color-danger">(之前的内容: {{data.beforeAccountIdName}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">{{data.accountType == 1 ? '营业执照编号' : '证件号码'}}: </span>{{data.userID}} 
                            <span v-if="data.beforeUserID" class="color-danger">(之前的内容: {{data.beforeUserID}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">{{data.accountType == 1 ? '营业执照' : '证件照片'}}: </span> 
                            <span v-if="data.accountPic">
                                <span v-for="(item,index) in data.accountPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.accountPic.split(',')"	></el-image>
                                </span>
                            </span>
                            <span v-if="data.beforeAccountPic">
                                <span class="color-danger">之前的内容:</span>
                                <span v-for="(item,index) in data.beforeAccountPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.beforeAccountPic.split(',')"	></el-image>
                                </span>
                            </span>
                        </el-col>
                        <el-col v-if="data.otherPic">
                            <span class="color-info">{{data.accountType == 1 ? '开户许可证' : '其他图片'}}: </span> 
                            <span v-if="data.otherPic">
                                <span v-for="(item,index) in data.otherPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.otherPic.split(',')"	></el-image>
                                </span>
                            </span>
                            <span v-if="data.beforeOtherPic">
                                <span class="color-danger">之前的内容:</span>
                                <span v-for="(item,index) in data.beforeOtherPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.beforeOtherPic.split(',')"	></el-image>
                                </span>
                            </span>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>状态信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col>
                            <span class="color-info">申请性质: </span>{{data.character == 1 ? '初次提交' : '二次提交'}} 
                        </el-col>
                        <el-col>
                            <span class="color-info">提交审核时间: </span>{{data.createTime}} 
                        </el-col>
                        <el-col>
                            <span class="color-info">审核状态: </span>{{data.status == 1 ? '待审核' : data.status == 2 ? '已通过' : '已拒绝'}} 
                        </el-col>
                        <el-col v-if="data.reviewerUser">
                            <span class="color-info">审核人: </span>{{data.reviewerUser}} 
                        </el-col>
                        <el-col v-if="data.reviewerTime">
                            <span class="color-info">审核时间: </span>{{data.reviewerTime}} 
                        </el-col>
                    </el-row>
                </el-card>
            </div>
        </template>
        <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
            <template v-if="$utils.have('/raise/receivables/audit') && data && data.status == 1">
                <el-button  @click="$refs.directUpdate.show(data,1)" type="success">通过</el-button>
                <el-button @click="$refs.directUpdate.show(data,2)" type="danger">拒绝</el-button>
            </template>
        </div>

        <DirectUpdate ref="directUpdate" @onUpdate="getDataDetail" :id="id"></DirectUpdate>

    </div>
</template>

<script>
import DirectUpdate from './components/directUpdate';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{DirectUpdate},
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/finance/activity/receivables/audit/list',
            data:null,
            character: this.$route.query.character,
        }
    },
    computed:{
        accountType(){
            return new Map([
                [1,'企业'],[2,'个人']
            ])
        }
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/receivables/getDetailInfo",
                params: { id: parseInt(this.id),character: this.character},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
        span{
            vertical-align: top;
        }
    }
    .img{
        margin: 8px 10px 0px 2px;
        display: inline-block;
        .el-image{
            width: 120px;
            height: 120px;
        }
    }
}
</style>